import Vue from 'vue'
import Vuex from 'vuex'
import VueLocalStorage from 'vue-localstorage'

Vue.use(VueLocalStorage, {
  name: 'ls',
  bind: true //created computed members from your variable declarations
})

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    user: {
      userName: '',
      phone: '',
      rank: 0,
      joined: false,
      cash: 0,
      chancesLeft: '',
      currLevel: '',
      currLevelIcon: '',
      milestones: [],
      mile_stones: [],
      balances: [],
      referralWalletData: false,
      referral_balances: [],
      use_wallet: true,
      headerBalance: {
        icon: '',
        balance: '',
        show: false
      },
      ext_uid: '',
      show_action_button_in_rewards: false,
      offers_show_currency_list: false,
      offers_show_currency_name: false,
      rewards_show_currency_list: false,
      rewards_show_currency_name: false,
      show_currency_name: false,
      show_currency_list: false,
      show_action_button: false,
    },
    partner: '',
    wallet: {
      type: '',
    },
    wallet_data: {},
    gameName: '',
    game: '',
    headTitle: '',
    totalUserPoints: 0,
    countDownTimer: "00h:00m:00s",
    history: true,
    alert: false,
    toast: false,
    alertText: "",
    toastMsg: "",
    refreshTournament: false,
    timer: "",
    showHeader: true,
    showHistory: true,
    showWallet: true,
    showHeaderBalance: false,
    isInfo: false,
    shareText: "",
    refreshTournamentTimer: null,
    refreshMainPageTimer: null,
    redeem: false,
    requestedTR: false,
    success: false,
    processing: false,
    mainPageTournaments: [],
    mainPageLeaderboard: [],
    mainPagePrizes: [],
    timersArray: [],
    allTournamentsList: [],
    lang: '',
    bg_theme: "",
    show_gift_modal: false,
    show_mile_stone_modal: false,
    gift_content: {},
    hasGamification: false,
    giftCardBuy: true,
    requestHeaders: null,
    environment: "STAGING",
    showExitModal: false,
    showQuizHistoryMenu: true,
    quizDetailsTitle: null,
    quizDetailsId: null,
    show_sc: true,
    quiz_time_bonus: 0,
    final_screen_data: null
  },
  getters: {
    gamesDomain: state => {
      var curr_domain = window.location.origin;
      if (curr_domain.includes("appbrowzer")) {
        return 'https://www.appbrowzer.com'
      } else {
        if(state.environment == "PRODUCTION"){
          return 'https://ghc.theflyy.com/api'
        } else {
          return 'https://ghc-stage.theflyy.com/api'
        }
      }
    },
    flyyDomain: state => {
      if(state.environment == "PRODUCTION"){
        return 'https://ghc.theflyy.com/api'
      } else {
        return 'https://ghc-stage.theflyy.com/api'
      }
    },
    headers: state => {
      var user = state.user;
      if (state.requestHeaders && state.requestHeaders != null) {
        return state.requestHeaders;
      }
      // /////////////Comment Below line to run locally
      return null;
      ///////////////// Till Here
      ////////////////// Uncomment Below code to run locally
       //state.environment = "STAGE"

      /*var ext_uid = "8962772168";//"8962772168";// "7828011085";
      var partner = "89a3e8bed066cc07268e"//"89a3e8bed066cc07268e";// "08c0758cd2ef8dfba42a" //"8fce343fa6170bf1ecb5";
      state.user.ext_uid = ext_uid;
      state.partner = partner;
      return {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        "X-Package-Name": "theflyy.com.flyysdk",
        "X-SDK-Version-Code": "10",
        "X-SDK-Version-Name": "1.0.10",
        "X-App-Version-Code": "1",
        "X-App-Version-Name": "1.0",
        "X-Android-Id": "2f0d7313fb91bc18",
        "X-GAID": "a71e7427-08dc-4ffd-af96-5e504bbd5d42",
        "X-App-Data": "",
        "X-Ext-UID": ext_uid,
        "X-Key": partner,
        "X-Token": "XjJS2dqH20",
        "X-User-Segment": ""
      }; */
      /////////////////// Till Here
    }
  },
  mutations: {
    SET_HEADERS: (state, headers) => {
      state.requestHeaders = headers
    }
  },
  actions: {
    setHeaders: ({commit, state}, newValue) => {
      commit('SET_HEADERS', newValue)
      return state.requestHeaders
    }
  }
});

export default store



// WEBPACK FOOTER //
// ./src/store.js